"use client";

import { useEffect } from "react";

/**
 * Development-only helpers installed on `window` for DevTools and the
 * DevTools LLM. Each module assigns its own global when imported:
 *
 *   window.chroma — chroma-js 3.2.0 (src/utils/chroma.mjs): chroma("tomato").hex(),
 *                   chroma.mix(a, b), chroma.contrast(a, b), chroma.scale([...]).colors(n)
 *
 * Production builds skip the import, so the library ships in no production chunk.
 */
export function DevWindowGlobals() {
    useEffect(() => {
        if (process.env.NODE_ENV === "production") {
            return;
        }
        void import("@/utils/chroma.mjs");
    }, []);

    return null;
}
